/**
 * Badges statut — templates & versions (F2-Forms-1c-i).
 * Couleur = signal + libellé texte (jamais couleur seule, a11y).
 */
import { useTranslation } from "react-i18next";

export function FormTemplateStatusBadge({ status }: { status: "active" | "archived" }) {
  const { t } = useTranslation();
  const isActive = status === "active";
  return (
    <span
      className={
        isActive
          ? "inline-flex rounded-full bg-emerald-50 px-2 py-0.5 text-xs font-medium text-emerald-700"
          : "inline-flex rounded-full bg-slate-100 px-2 py-0.5 text-xs font-medium text-slate-600"
      }
    >
      {t(`form_templates.status.${status}`)}
    </span>
  );
}

/** État de la dernière version : brouillon (published_at null) ou publiée. */
export function FormVersionStateBadge({ publishedAt }: { publishedAt: string | null }) {
  const { t } = useTranslation();
  const isPublished = publishedAt !== null;
  return (
    <span
      className={
        isPublished
          ? "bg-brand-50 text-brand-700 inline-flex rounded-full px-2 py-0.5 text-xs font-medium"
          : "inline-flex rounded-full bg-amber-50 px-2 py-0.5 text-xs font-medium text-amber-700"
      }
    >
      {t(
        isPublished
          ? "form_templates.version_state.published"
          : "form_templates.version_state.draft",
      )}
    </span>
  );
}
